/**
 * Static Blocks Module
 *
 * Definisce i blocchi statici sotto al booking-engine in homepage,
 * differenziati per package_type (FLIGHT_AND_STAY / ONLY_STAY).
 *
 * Ogni blocco è formato da: { image, heading, texts[], caption }
 * dove texts[] è una lista di { value, hidden? }
 */

import { PACKAGE_TYPES } from "@alpitour/resources/package_types";

export const STATIC_BLOCKS = {
  [PACKAGE_TYPES.FLIGHT_AND_STAY]: [
    {
      image: "assets/images/alpitour/statics/hp-static-1.jpg",
      heading: "Cosa è incluso?",
      texts: [
        { value: "I pacchetti sono Volo+Hotel" },
        { value: "e includono trasferimenti* ed assicurazione" },
      ],
      caption: `Scopri i dettagli di ogni pacchetto usando il motore di ricerca qui sopra. Puoi trovare maggiori informazioni sulle condizioni contrattuali ed assicurative nella nostra pagina Condizioni d'uso.
        *I trasferimenti potrebbero non essere sempre inclusi. Per maggiori dettagli, verifica le informazioni presenti nel pacchetto scelto o contatta la nostra assistenza.`,
    },
    {
      image: "assets/images/alpitour/statics/hp-static-2.jpg",
      heading: "Ti aspettiamo in aeroporto",
      texts: [
        { value: "Alla partenza e all'arrivo a destinazione" },
        { value: "#", hidden: true },
      ],
      caption: `Ti assisteremo in Italia per le formalità di imbarco e all'arrivo a destinazione per gestire il tuo trasferimento in hotel con mezzi riservati. (Valido per tutti i voli charter e di linea charterizzati, chiedi i dettagli alla nostra assistenza).`,
    },
  ],
  [PACKAGE_TYPES.ONLY_STAY]: [
    {
      image: "assets/images/alpitour/statics/hp-static-only-stay-1.jpg",
      heading: "Prenota l’hotel, al viaggio pensi tu",
      texts: [
        { value: "La soluzione flessibile per chi ama viaggiare in autonomia," },
        { value: "senza rinunciare alla qualità del soggiorno" },
      ],
      caption: `Ti garantiamo i migliori standard di accoglienza e supporto durante tutta la tua permanenza nella struttura scelta. Potrai gestire la tua prenotazione con la massima flessibilità, contando sempre su tariffe competitive e un’assistenza a portata di click.`,
    },
    {
      image: "assets/images/alpitour/statics/hp-static-only-stay-2.jpg",
      heading: "New: villaggi e resort",
      texts: [
        { value: "Scegli tra i migliori villaggi, hotel e resort." },
        { value: "Ti aspettiamo a destinazione" },
      ],
      caption: `Scegli l’esperienza dei migliori club e resort. Ti garantiamo l’eccellenza dell’ospitalità Alpitour con soluzioni pensate per famiglie, coppie o amici. Goditi i vantaggi dei club più esclusivi. Tu scegli come arrivare, al resto pensiamo noi!`,
    },
  ],
};